<template>
  <v-form>
    <v-row>
      <v-col cols="12" md="10">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="name"
              clear-icon="mdi-close"
              label="Tên tuyến"
              flat
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="status"
              :items="busStatus"
              clear-icon="mdi-close"
              item-text="title"
              item-value="status"
              label="Chọn trạng thái"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="phone"
              clear-icon="mdi-close"
              label="Số điện thoại"
              flat
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col class="d-flex align-end" cols="12" md="2">
        <v-btn dark outlined class="search-button" @click="onFilterChanged">
          Tìm kiếm
        </v-btn>
        <v-spacer />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {},
  data: () => ({
    status: '',
    phone: '',
    name: '',
    busData: '',
    driver: '',
    data: {
      maxStudent: ''
    }
  }),
  computed: {
    ...mapState('constant', ['busStatus'])
  },
  methods: {
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        name_contains: this.name,
        status: this.status,
        phone_contains: this.phone
      })
    }
  }
}
</script>

<style scoped></style>
